import * as R from 'remeda'
import { palette } from './palette'
import { palette as borderPalette } from './borderPalette'
import { colors } from './tokens'

const shadows = {
  none: 'none',
  ...borderPalette,
  ...R.mapKeys(colors.border, k => `border/${k}`),
}
export const getColors = () => ({
  opacities: {
    '0': 0,
    '2': 0.02,
    '3': 0.03,
    '4': 0.04,
    '8': 0.08,
    '12': 0.12,
    '16': 0.16,
    '20': 0.2,
    '24': 0.24,
    '32': 0.32,
    '40': 0.4,
    '48': 0.48,
    '64': 0.64,
    '72': 0.72,
    '80': 0.8,
    '96': 0.96,
    '100': 1,
  },
  colors: {
    ...palette,
    transparent: 'transparent',
    white: '#FFF',
    black: '#000',
    inherit: 'inherit',
    // Figma Tokens Studio doesn't support radial gradients or multi-layer bg so we need to hardcode some backgrounds
    /**
     * Gradients with alpha look a bit different because browsers use premultiplied alpha color
     * space while figma doesn't and there's no way to change either of them
     * https://forum.figma.com/ask-the-community-7/wrong-gradient-behavior-with-opacity-36185?postid=141894#post141894
     *
     * We also need to manually adjust radial-gradient size because something is off compared to
     * what figma generates as css and what it renders in the figma app
     */
    'bg/background-gradient': `radial-gradient(50% 80% at 70% 0%, ${colors.base['transparency-orange-at-64']} 0%, ${colors.bg.invisible} 100%), linear-gradient(270deg, ${colors.base['purple-64']} 0%, ${colors.bg.navigation} 100%)`,
    'bg/background-gradient-email': `linear-gradient(223deg, ${colors.base['transparency-orange-at-64']} 1.35%, ${colors.bg.invisible} 41.96%), linear-gradient(180deg, ${colors.base['purple-64']} 0%, ${colors.bg.navigation} 56.39%)`,
    ...R.mapKeys(colors.bg, k => `bg/${k}`),
    ...R.mapKeys(colors.fg, k => `fg/${k}`),
    ...R.mapKeys(colors.effect, k => `effect/${k}`),
  },
  shadows,
})
